module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var u = require('util/Util.js').default;
var tu = require('util/TextUtil.js').default;

    ; __append("\r\n")
    ;  
        let localizedText = u.getLocalizedText(id, 'text') || text;  
    
    ; __append("\r\n<div id=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"pf-control pf-editable smallheading text has-menu\" tabindex=\"")
    ; __append(escapeFn( tabIndex ))
    ; __append("\" draggable=\"true\"\r\n     style=\"left:")
    ; __append(escapeFn( left ))
    ; __append("px; top:")
    ; __append(escapeFn( top ))
    ; __append("px; width: ")
    ; __append(escapeFn( u.extractNum(width)))
    ; __append("px; height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px; z-index:")
    ; __append(escapeFn( zOrder ))
    ; __append("; \">\r\n\r\n    <div class=\"size-handle-top\"    style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-left\"   style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n\r\n    <div class=\"pf-control-core pf-selectable wordwrap pf-html-text\"    style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px; width: ")
    ; __append(escapeFn( u.extractNum(width) ))
    ; __append("px;\r\n            overflow:hidden; white-space: pre-wrap;word-wrap: break-word;\r\n            text-align: ")
    ; __append(escapeFn( align ))
    ; __append("; font-family: ")
    ; __append(escapeFn(u.resolveCompliantFontFamilyName(fontFamily)))
    ; __append(";\r\n            font-size: ")
    ; __append(escapeFn(fontSize))
    ; __append("px; font-style: ")
    ; __append(escapeFn(textStyle))
    ; __append("; font-weight: ")
    ; __append(escapeFn(textWeight))
    ; __append(";\r\n            color: ")
    ; __append(escapeFn( styleColorText))
    ; __append(";\">")
    ; __append( tu.getNewText(localizedText, isHtml) )
    ; __append("</div>\r\n\r\n    <div class=\"size-handle-right\"  style=\"height: ")
    ; __append(escapeFn( u.extractNum(height) ))
    ; __append("px;\"></div>\r\n    <div class=\"size-handle-bottom\" style=\"width:  ")
    ; __append(escapeFn( u.extractNum(width)  ))
    ; __append("px;\"></div>\r\n</div>")
  }
  return __output;

}